import Seo from "./Seo";
import Facebook from "./Facebook";
import Twitter from "./Twitter";

export { Facebook, Twitter };

export default Seo;
